/* Main part of the clickable export thing, contains image, header, text */

import { BoxProps, HStack, Spacer } from "@chakra-ui/react";
import { ReactNode } from "react";

import { DISABLED_OPACITY } from "@nens/ranalib";

import styles from "../ExportMenu.module.css";

interface ExportRowMainProps extends BoxProps {
  exportImage?: {
    src: string;
    alt: string;
  };
  tag?: ReactNode;
  selected: boolean;
  disabled?: boolean;
}

export default function ExportRowMain({
  onClick,
  exportImage,
  tag,
  children,
  selected,
  disabled = false,
  ...rest
}: ExportRowMainProps) {
  return (
    <HStack
      onClick={onClick}
      justifyContent="start"
      gap="4px"
      w="100%"
      m="2px 0"
      opacity={disabled ? DISABLED_OPACITY : undefined}
      bgColor={selected ? "brand.light_sky" : undefined}
      padding="8px"
      border="solid 1px"
      borderRadius="4px"
      borderColor="brand.glacier"
      cursor="pointer"
    >
      {exportImage ? (
        <img className={styles.ExportImage} src={exportImage.src} alt={exportImage.alt} />
      ) : null}
      <div className={styles.ExportText}>
        <div>{children}</div>
      </div>
      {tag ? (
        <>
          <Spacer />
          <HStack gap="8px" mr="32px" fontWeight="semibold">
            {tag}
          </HStack>
        </>
      ) : null}
    </HStack>
  );
}
